<template>
    <button type="button" :class="`btn-${type} ${classes}`" class="btn" :disabled="disabled" @click="handleClick">
        <slot></slot>
    </button>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'Button',
    props: {
        disabled: Boolean,
        type: String,
        classes: {
            type: String,
            default() {
                return '';
            }
        }
    },
    components: {},
    methods: {
        handleClick(event) {
            this.$emit('click', event);
        }
    },
    computed: {
        ...mapState(['changeColor'])
    },
    mounted() {
        this.button = document.querySelectorAll('button.btn-primary');
        if (this.button) {
            for (let item in this.button) {
                if (this.button[item] && this.button[item].style) {
                    this.button[item].style.backgroundColor = this.changeColor;
                }
            }
        }
    }
};
</script>

<style lang="scss"></style>
